<template>
  <SoDialog
    v-model="value"
    :max-width="1200"
    card-title="Installation Guide Booklet"
    data-testid="installation-guide-modal"
  >
    <embed
      src="https://soenergy-so-watt.s3.eu-west-2.amazonaws.com/so-energy-booklet.pdf"
      width="100%"
      height="700px"
    />
  </SoDialog>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import SoDialog from "@/components/SoDialog.vue"

  export default defineComponent({
    components: {
      SoDialog,
    },
    props: {
      modelValue: {
        type: Boolean,
        default: false,
        required: true,
      },
    },
    emits: ["update:modelValue"],
    computed: {
      value: {
        get() {
          return this.modelValue
        },
        set(value: boolean) {
          this.$emit("update:modelValue", value)
        },
      },
    },
  })
</script>
